import { ActionButton } from '@/ui/components/buttons/action'
import { CustomTextField } from '@atbay/component-lib'
import { styled } from '@mui/system'

export const NotInvitedContentWrapper = styled('div')`
    .title {
        line-height: 36.8px;
    }

    .description {
        margin-top: 31px;
    }

    .form {
        margin-top: 35px;

        label {
            font-size: var(--font-size-xs);
            color: var(--color-greys-400);
        }
    }

    .action-button-wrapper {
        display: flex;
        justify-content: center;
        margin-top: 59px;
    }
`

export const StyledActionButton = styled(ActionButton)``

export const StyledTextField = styled(CustomTextField)``
